document.addEventListener('DOMContentLoaded', function () {
  // Function to reinitialize Rebuy
  function reinitializeRebuy() {
    if (typeof Rebuy !== 'undefined' && Rebuy.init) {
      Rebuy.init(); // Adjust this based on Rebuy’s actual API method
    }
  }

  setInterval(() => {
    reinitializeRebuy();
  }, 1000);
});

jQuery(document).ready(function () {
  jQuery('.get-help ul li#chat-with-us a').on('click', function (e) {
    e.preventDefault();
    if (window.GorgiasChat) {
      window.GorgiasChat.open();
    }
  });
});
$(document).ready(function () {
  $(".mobile-close-icon").on("click", function () {
    $(this).parents('details').removeAttr('open');
    $(this).parents('.mobile-facets__disclosure').removeClass('menu-opening');
    $('.facets-vertical').removeClass('facets-vertical-active');
    $('body').removeClass('overflow-hidden-mobile');
  });
});

function toggleGoToAccessories() {
  const accessories = document.querySelector('.accessories-dynamic-wrapper');
  const goToLink = document.querySelector('.go-to-accessories');
  if (!goToLink) return;

  if (!accessories || window.getComputedStyle(accessories).display === 'none') {
    goToLink.style.display = 'none';
  } else {
    goToLink.style.display = '';
  }
}

document.addEventListener('DOMContentLoaded', toggleGoToAccessories);
window.addEventListener('resize', toggleGoToAccessories);

const accessoriesObserver = new MutationObserver(toggleGoToAccessories);
const accessoriesTarget = document.querySelector('.accessories-dynamic-wrapper');
if (accessoriesTarget) {
  accessoriesObserver.observe(accessoriesTarget, { attributes: true, attributeFilter: ['class'] });
}

document.addEventListener('click', function (event) {
  const link = event.target.closest('.go-to-accessories-link');
  if (!link) return;

  event.preventDefault();

  const accessories = document.querySelector('.accessories-scroll-target');

  if (accessories) {
    accessories.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
});
